var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonTooltip',{class:_vm.buttonClasses,attrs:{"color":"primary","small":"","tooltip-text":`${
    _vm.bookmarkStore.isPathBookmarked
      ? 'Remove from Bookmarks'
      : 'Add to Bookmarks'
  }`,"tooltip-props":{ 'nudge-bottom': 8 },"icon-name":_vm.bookmarkStore.isPathBookmarked ? 'fa-bookmark' : 'fa-plus',"button-text-right":_vm.bookmarkStore.isPathBookmarked ? 'Unbookmark' : 'Bookmark'},on:{"click":_vm.bookmarkStore.toggleBookmarks}})
}
var staticRenderFns = []

export { render, staticRenderFns }